import {
  Button,
  Card,
  Col,
  Collapse,
  Divider,
  Flex,
  Form,
  FormInstance,
  Modal,
  Row,
  Select,
  Spin,
  Tooltip,
  Typography,
} from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import iconDown from "../../assets/images/booking/icon-down.svg";
import iconExport from "../../assets/images/booking/icon-export.svg";
import iconSearch from "../../assets/images/booking/icon-search.svg";
import IcEditTicket from "../../assets/images/diagram/ic-edit.svg";
import IcMoveTicket from "../../assets/images/diagram/ic-move-ticket.svg";
import IcPrintTicket from "../../assets/images/diagram/ic-print.svg";
import IcSendMail from "../../assets/images/diagram/ic-send-mail.svg";
import "../../assets/styles/desktop/busBooking.scss";
import ModalCancelTicket from "../../components/Modal/ModalCancelTicket";
import { Constant } from "../../config/constant";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { setReloadDetail } from "../../redux/slice/authSlice";
import {
  createBookingSelector,
  filterBookingCustomer,
  resetBooking,
  resetListCustomers,
} from "../../redux/slice/bookings/createBookingSlice";
import { destroyBooking } from "../../redux/slice/bookings/destroyBookingSlice";
import {
  holdingBookingSelector,
  resetDataBooking,
} from "../../redux/slice/bookings/holdingBookingSlice";
import {
  listBookingSelector,
  resetDataMoveTicket,
} from "../../redux/slice/bookings/listBooking";
import {
  moveTicketSelector,
  resetListAvailableSeat,
  resetMoveTicket
} from "../../redux/slice/bookings/moveTicketSlice";
import {
  getSendBookingMail,
  updateBookingSelector,
} from "../../redux/slice/bookings/updateBooking";
import ModalHistoryBooking from "./ModalHistoryBooking";
import ModalPrintTicket from "./tickets/ModalPrintTicket";

import {
  convertTimeFormat,
  formattedPrice,
  imageStatusTicket,
} from "../../lib/utils";
import { getDataBookingSeat } from "../../redux/slice/bookings/bookingTicketSlice";
import {
  getListBookingDetail,
  listDetailTicketSelector,
  resetListBookingDetail,
} from "../../redux/slice/bookings/listDetailTicketSlice";
import { setIsPrintTicket } from "../../redux/slice/bookings/printTicketSlice";
import { getPriceScheduleReason } from "../../utils/helpers";
import ModalChangeBooking from "./changeBooking/ModalChangeBooking";
import CountdownComponent from "./diagrams/Countdown";
import ModalBooking from "./ModalBooking";
import ModalExportTicket from "./ModalExportTicket";
const ModalBookingDetail: React.FC<any> = ({
  okText,
  cancelText,
  modalOpen,
  onCancel,
  onOk,
  listBooking,
  listBookingDetailSeat,
  loading,
  dataCustomerBooking,
  formSearch,
  seat_number,
  searchDateBooking,
  isBooking,
}) => {
  const { t } = useTranslation();
  const { status: statusCreateUpdate, loading: loadingCreate } = useAppSelector(
    createBookingSelector
  );
  const { dataBooking, loading: loadingHold } = useAppSelector(
    holdingBookingSelector
  );
  const { dataMoveTicket, status: statusMoveTicket } =
    useAppSelector(moveTicketSelector);
  const { dataMoveTicket: dataMoveTicketDiagram, isMoveTicket } =
    useAppSelector(listBookingSelector);
  const {
    loadingListBooking: loadingDetailList,
    listBookingDetail,
    loading: loadingDetail,
  } = useAppSelector(listDetailTicketSelector);
  const { loadingSend } = useAppSelector(updateBookingSelector);
  const [isModalOpen, setIsModalOpen] = useState(modalOpen);
  const [isOpenModalCancelTicket, setIsOpenModalCancelTicket] = useState(false);
  const [openModalChangeBooking, setOpenModalChangeBooking] = useState(false);
  const [formBooking]: [FormInstance] = Form.useForm();
  const dispatch = useAppDispatch();
  const [openModalHistory, setOpenModalHistory] = useState(false);
  const [openModalBooking, setOpenModalBooking] = useState(false);
  const [openModalExportTicket, setOpenModalExportTicket] = useState(false);
  const [isDetail, setIsDetail] = useState(false);
  const [openModalPrint, setOpenModalPrint] = useState(false);
  const [countdownFinished, setCountdownFinished] = useState(false);
  const isAgentId = Form.useWatch("is_agent_id", formBooking);
  const agentId = Form.useWatch("agent_id", formBooking);

  useEffect(() => {
    setIsModalOpen(modalOpen);
  }, [modalOpen]);

  const modalHandleOk = () => {
    onOk();
  };

  const modalHandleCancel = () => {
    if (
      !isDetail &&
      statusCreateUpdate !== Constant.DEFAULT_STATUS &&
      dataBooking?.ticket_code
    ) {
      dispatch(
        destroyBooking({
          ticket_code: [dataBooking?.ticket_code],
        })
      );
    }
    formBooking.resetFields();
    dispatch(resetListBookingDetail());
    onCancel();
    dispatch(resetBooking());
    dispatch(resetDataBooking());
    setCountdownFinished(false);
    dispatch(resetListCustomers());
    if (dataMoveTicketDiagram?.ticket_code || isMoveTicket) {
      dispatch(resetDataMoveTicket());
      dispatch(resetMoveTicket());
    }
  };
  const cancelModalBooking = () => {
    setOpenModalBooking(false);
  };
  const cancelChangBookingModal = () => {
    setOpenModalChangeBooking(false);
    dispatch(resetListAvailableSeat());
    dispatch(resetMoveTicket());
    dispatch(resetDataMoveTicket());
  };
  const handleOkChangeBooking = () => {};
  const handleOkModalBooking = () => {};

  function onSearchTicket(value: any) {
    // setKeywordTicket(value);
  }
  const scrollToErrorField = (errorFields: any) => {
    const [firstErrorField] = errorFields;
    if (firstErrorField) {
      formBooking.scrollToField(firstErrorField.name);
    }
  };
  const handleCancelTicket = () => {
    setIsOpenModalCancelTicket(false);
  };
  const handleOkeTicket = () => {};
  const onFinish = (values: any) => {};
  const onChangeTicket = () => {};
  const cancelModalHistory = () => {
    setOpenModalHistory(false);
  };

  const cancelModalPrint = () => {
    dispatch(setReloadDetail());
    setOpenModalPrint(false);
    // setDataPrint(undefined);
    dispatch(setIsPrintTicket(false));
  };

  const genExtra = () => (
    <>
      <img src={iconDown} alt="" />
    </>
  );
  const onChangeCollapse = (key: string | string[]) => {};
  const handleEditBooking = (
    key: string,
    index: number,
    ticket_code: string,
    id: number,
    seatInfo: any
  ) => {
    if (key === "Chỉnh sửa" && ticket_code) {
      setOpenModalBooking(true);
      setIsDetail(true);
      dispatch(getListBookingDetail({ ticket_code: ticket_code }));
    }
    if (key === "Gửi mail" && id) {
      dispatch(getSendBookingMail(id));
    }
    if (key === "In vé" && id) {
      dispatch(setReloadDetail());
      // setDataPrint(seatInfo);
      setOpenModalPrint(true);
      dispatch(getListBookingDetail({ ticket_code: ticket_code }));
      dispatch(setIsPrintTicket(true));
    }
  };
  const handleExportTicket = (
    ticket_code: string,
    id: number,
    seatInfo: any
  ) => {
    dispatch(getListBookingDetail({ ticket_code: ticket_code }));
    setOpenModalExportTicket(true);
  };
  const handleMoveTicket = (ticket_code: string, id: number, seatInfo: any) => {
    setOpenModalChangeBooking(true);
    dispatch(
      getDataBookingSeat({
        ticket_codes: [ticket_code],
      })
    );
  };
  const generateCollapseItem = (
    key: string,
    label: string,
    className: string,
    data: any[] = [],
    iconClass: string
  ) => ({
    key,
    label: (
      <Flex gap={12}>
        <span>{label}</span>
        {data?.length ? <div className="num-person">{data.length}</div> : ""}
      </Flex>
    ),
    children: (
      <>
        {data?.length
          ? data.map((booking: any, index: number) => (
              <div key={`${key}-${index}`}>
                <Flex
                  align="center"
                  className="w-100 justify-between items-center"
                >
                  <Row
                    className="w-100 d-flex items-center"
                    gutter={18}
                    style={{ margin: 0 }}
                  >
                    <Col
                      span={1}
                      className="d-flex justify-center align-center w-100"
                    >
                      <img src={imageStatusTicket(booking)} alt="" />
                    </Col>
                    <Col
                      span={2}
                      className="d-flex justify-center flex-wrap w-full items-center"
                    >
                      <p className="fs-16 fw-500 text-blue">
                        {booking?.ticket_code}
                      </p>
                      {className === "reserve" && booking?.expired_at && (
                        <CountdownComponent seatEntriesExpired={booking} />
                      )}
                    </Col>
                    <Col
                      span={5}
                      className="d-flex flex-column justify-center flex-wrap w-full"
                    >
                      <p className="fs-16 fw-500 text-blue">
                        {booking?.customer_name || ""}
                      </p>
                      <p className="fs-16 fw-500 text-light-blue">
                        {booking?.status === "open_api"
                          ? "N/A"
                          : booking?.customer_phone ?? ""}
                      </p>
                    </Col>
                    <Col
                      span={7}
                      className="d-flex flex-column justify-center flex-wrap w-full"
                    >
                      <p className="fs-16 fw-500 text-blue">
                        {booking?.start_location
                          ? `${booking.start_location} - ${booking.end_location}`
                          : ""}
                      </p>
                      <p className="fs-16 fw-500 text-light-blue">
                        {booking?.pickup_time
                          ? `Giờ đi: ${convertTimeFormat(
                              booking.pickup_time
                            )} - ${booking.pickup_date}`
                          : ""}
                      </p>
                    </Col>
                    <Col
                      span={2}
                      className="d-flex justify-center flex-wrap w-full"
                    >
                      <p className="fs-16 fw-500 text-blue">
                        {booking?.price_change
                          ? formattedPrice(booking?.price_change)
                          : formattedPrice(booking?.final_price)}
                      </p>
                      <p className="fs-13 fw-500 text-success">
                        {getPriceScheduleReason(booking?.price_schedule, true)}
                      </p>
                    </Col>
                    <Col
                      span={7}
                      className="w-full"
                      style={{ paddingRight: 0 }}
                    >
                      <Flex
                        align="center"
                        gap={10}
                        className="block-btn-edit"
                        justify="end"
                      >
                        {booking?.status === "reserve" &&
                          ((listBooking?.trip?.status !== "canceled" &&
                            listBooking?.trip?.status !== "departed") ||
                            !isBooking) && (
                            <Button
                              className="btn-diagram"
                              key={"btn-export-ticket"}
                              onClick={() =>
                                handleExportTicket(
                                  booking?.ticket_code,
                                  booking?.id,
                                  booking
                                )
                              }
                            >
                              <Tooltip title={"Xuất vé"} placement="top">
                                <img src={iconExport} alt="Export" />
                              </Tooltip>
                            </Button>
                          )}
                        {booking?.source !== "openapi" ? (
                          <Button
                            className="btn-diagram"
                            key={"btn-export-ticket"}
                            onClick={() =>
                              handleMoveTicket(
                                booking?.ticket_code,
                                booking?.id,
                                booking
                              )
                            }
                          >
                            <Tooltip title={"Chuyển vé"} placement="top">
                              <img src={IcMoveTicket} alt="Move" />
                            </Tooltip>
                          </Button>
                        ) : (
                          ""
                        )}
                        {booking?.status !== "open_api" ? (
                          <>
                            {["Chỉnh sửa", "In vé", "Gửi mail"].map(
                              (tooltip, idx) => (
                                <Button
                                  className="btn-diagram"
                                  key={tooltip + idx}
                                  onClick={() =>
                                    handleEditBooking(
                                      tooltip,
                                      idx,
                                      booking?.ticket_code,
                                      booking?.id,
                                      booking
                                    )
                                  }
                                >
                                  <Tooltip title={tooltip} placement="top">
                                    <img
                                      src={
                                        [
                                          IcEditTicket,
                                          IcPrintTicket,
                                          IcSendMail,
                                        ][idx]
                                      }
                                      alt={tooltip}
                                    />
                                  </Tooltip>
                                </Button>
                              )
                            )}
                          </>
                        ) : (
                          ""
                        )}
                      </Flex>
                    </Col>
                  </Row>
                </Flex>
                {data?.length > 0 && (
                  <Divider style={{ margin: "10px 0" }} className="h-0" />
                )}
              </div>
            ))
          : ""}
      </>
    ),
    collapsible: data && data?.length ? undefined : "disabled",
    extra: genExtra(),
    showArrow: false,
    className,
  });
  const items: any = [
    listBookingDetailSeat?.reserve?.length
      ? generateCollapseItem(
          "1",
          "Đang giữ chỗ",
          "reserve",
          listBookingDetailSeat.reserve,
          "reserve"
        )
      : null,
    listBookingDetailSeat?.paid?.length
      ? generateCollapseItem(
          "2",
          "Đã thanh toán",
          "payment",
          listBookingDetailSeat.paid,
          "payment"
        )
      : null,
    listBookingDetailSeat?.open_api?.length
      ? generateCollapseItem(
          "3",
          "Chờ xác nhận thanh toán",
          "confirm",
          listBookingDetailSeat.open_api,
          "open_api"
        )
      : null,
  ]?.filter(Boolean);

  useEffect(() => {
    dispatch(filterBookingCustomer({}));
  }, [dispatch]);
  useEffect(() => {
    if (countdownFinished) {
      modalHandleCancel();
    }
  }, [countdownFinished]);
  useEffect(() => {
    if (statusCreateUpdate === Constant.DEFAULT_STATUS) {
      setOpenModalExportTicket(false);
    }
  }, [statusCreateUpdate]);

  useEffect(() => {
    if (statusMoveTicket === Constant.DEFAULT_STATUS) {
      setOpenModalChangeBooking(false);
      dispatch(resetMoveTicket());
      cancelChangBookingModal();
    }
  }, [statusMoveTicket]);
  return (
    <Modal
      open={isModalOpen}
      onOk={modalHandleOk}
      onCancel={modalHandleCancel}
      cancelText={cancelText}
      okText={okText}
      centered
      footer={
        <>
          <Row style={{ position: "absolute", bottom: 10, right: 30 }}>
            <Button
              key="cancel"
              className=" w-160 h-btn-48"
              onClick={() => modalHandleCancel()}
            >
              {cancelText}
            </Button>
          </Row>
        </>
      }
      width={980}
      maskClosable={false}
      className="modal-bus-booking detail"
      confirmLoading={loading || loadingCreate || loadingSend || loadingHold}
    >
      <Spin spinning={loadingDetail}>
        <Card className="card-modal-booking w-100">
          <Row
            style={{
              display: "flex",
              justifyContent: "space-between",
              paddingBottom: 4,
              borderBottom: "1px solid #EEEEEE",
            }}
          >
            <Typography.Text className="fw-600 fs-18 ">
              {t(
                `Danh sách hành khách - Ghế ${seat_number ? seat_number : ""}`
              )}
            </Typography.Text>
            <div style={{ marginRight: "35px" }}></div>
          </Row>
          <Spin
            spinning={loading || loadingCreate || loadingSend || loadingHold}
          >
            <Form
              layout="vertical"
              className=""
              form={formBooking}
              onFinish={onFinish}
              autoComplete="off"
              validateTrigger="onSubmit"
              labelAlign={"left"}
              labelWrap
              onFieldsChange={(allFields) => {
                scrollToErrorField(
                  allFields.filter(
                    (field) => field.errors && field.errors.length > 0
                  )
                );
              }}
              initialValues={{ is_agent_id: false }}
            >
              <Row className={`time-countdown-block mt-4`}>
                <Col className="w-300">
                  <Form.Item name="keyword">
                    <Select
                      placeholder={t("Nhập SĐT / mã vé để tìm kiếm")}
                      showSearch
                      disabled={isMoveTicket && dataMoveTicket?.ticket_code}
                      className="search-ticket"
                      suffixIcon={<img src={iconSearch} alt="" />}
                      onSearch={onSearchTicket}
                      onChange={onChangeTicket}
                      optionFilterProp="children"
                      filterOption={(input, option: any) =>
                        String(option.props.children)
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0 ||
                        String(option.props.value)
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      size="large"
                      style={{ width: "100%" }}
                      getPopupContainer={() => {
                        let ticketSearch: any =
                          document.body.getElementsByClassName("search-ticket");
                        return ticketSearch[0];
                      }}
                      optionLabelProp="value"
                    ></Select>
                  </Form.Item>
                </Col>
                <div className="d-flex justify-between w-100 mt-1 detail-booking-content">
                  <Collapse
                    onChange={onChangeCollapse}
                    items={items}
                    defaultActiveKey={["1", "2", "3"]}
                  />
                </div>
              </Row>
              <ModalCancelTicket
                modalOpen={isOpenModalCancelTicket}
                okText={t("Hủy vé")}
                cancelText={t("Trở lại")}
                modalTitle={t("Hủy vé")}
                onCancel={handleCancelTicket}
                onOk={handleOkeTicket}
                listBooking={listBooking}
                modalContent={t(
                  "Bạn đang thao tác hủy vé này, bạn có chắc chắn muốn hủy?"
                )}
                isAgentId={isAgentId}
                agentId={agentId}
              />
              <ModalHistoryBooking
                modalOpen={openModalHistory}
                onOk={() => setOpenModalHistory(false)}
                onCancel={cancelModalHistory}
                historyDetail={listBookingDetailSeat}
                listBooking={listBooking}
                isCancel={false}
              />
              <ModalPrintTicket
                modalOpen={openModalPrint}
                onCancel={cancelModalPrint}
                onOk={() => setOpenModalPrint(false)}
                listBooking={listBooking}
                listBookingDetailSeat={listBookingDetailSeat}
                dataCustomerBooking={dataCustomerBooking}
                listBookingDetail={listBookingDetail}
                // loading={loadingListBookingDetail}
              />
            </Form>
          </Spin>
        </Card>
      </Spin>
      <ModalBooking
        okText={"Lưu"}
        modalOpen={openModalBooking}
        onCancel={cancelModalBooking}
        cancelText={"Đóng"}
        onOk={handleOkModalBooking}
        listBooking={listBooking}
        formSearch={formSearch}
        isDetail={isDetail}
        listBookingDetail={listBookingDetail}
        loading={loading}
        // isDepart={isDepart}
        isBooking={isBooking}
        // isChangeTicket={isChangeTicket}
      />
      <ModalExportTicket
        modalOpen={openModalExportTicket}
        onOk={() => false}
        onCancel={() => setOpenModalExportTicket(false)}
        listBookingDetail={listBookingDetail}
        listBooking={listBooking}
        loadingDetailList={loadingDetailList}
        searchDateBooking={searchDateBooking}
      />
      <ModalChangeBooking
        okText={"Lưu"}
        modalOpen={openModalChangeBooking}
        onCancel={cancelChangBookingModal}
        cancelText={"Đóng"}
        onOk={handleOkChangeBooking}
        listBooking={listBooking}
        formSearch={formSearch}
        isDetail={isDetail}
        listBookingDetail={listBookingDetail}
        searchDateBooking={searchDateBooking}
      />
    </Modal>
  );
};
export default ModalBookingDetail;
